import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import { defaultPostCustomerAccountReadPtaTotalListApiForm } from "../interface";
import { usePostCustomerAccountReadPtaTotalList } from "../hooks/usePostCustomerAccountReadPtaTotalList";
import { useForm } from 'react-hook-form';
import EmptyTableRow from "../../../../common/EmptyTableRow";

interface PTASearchProps {
    itemName: string;
    keyword: string;
    keywordType: string;
    limit: number;
    pageNo: number;
    partNo: string;
    month: string;
    year: string;
}

const PTASearch = ({ name }: { name: string | null }) => {
    const [pageNo, setPageNo] = useState<number>(1);
    const [searchParams, setSearchParams] = useState<PTASearchProps>((() => ({
        ...defaultPostCustomerAccountReadPtaTotalListApiForm,
        keyword: name ?? "",
        year: new Date().getFullYear().toString(),
        month: (new Date().getMonth() + 1).toString().padStart(2, "0")
    }))());
    const { data: postCustomerAccountReadPtaTotalList } = usePostCustomerAccountReadPtaTotalList(searchParams);

    const { register, handleSubmit } = useForm({ defaultValues: searchParams });

    useEffect(() => {
        if (!postCustomerAccountReadPtaTotalList) return;

        console.log("📄 PTA 리스트:", postCustomerAccountReadPtaTotalList.result.list);
        console.log("🔢 총 개수:", postCustomerAccountReadPtaTotalList.result.totalCount);
    }, [postCustomerAccountReadPtaTotalList]);

    useEffect(() => {
        setSearchParams({ ...searchParams, pageNo: pageNo });
    }, [pageNo]);

    // 현재 연도와 월 (Date 객체 사용)
    const currentYear = new Date().getFullYear();

    // 50년치 연도 리스트 생성
    const yearList = Array.from({ length: 51 }, (_, idx) => currentYear - idx);

    // 월 리스트 생성 ('01' ~ '12')
    const monthList = Array.from({ length: 12 }, (_, idx) => {
        const month = idx + 1;
        return month.toString().padStart(2, "0");
    });

    const onSubmit = (data: PTASearchProps) => {
        setSearchParams({ ...data, pageNo: 1 });
    }

    return <>
        <Modal.Header closeButton>
            <Modal.Title>PTA 레벨 전체보기</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="fiter_wrap no-shadow border-0 p-0">
                    <div className="row mb-15px">
                        <div className="col-6">
                            <div className="frm_row search justify-content-start">
                                <label className="form-label frm_label">검색어</label>
                                <select className="form-select w-150px me-5px" {...register('keywordType')} >
                                    <option value={'1'}>ERP 거래처명</option>
                                    <option value={'2'}>pricing group</option>
                                    <option value={'3'}>price tier</option>
                                    <option value={'4'}>erp 코드</option>
                                </select>
                                <input className="form-control" {...register('keyword')} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="frm_row">
                                <label className="form-label frm_label">날짜</label>
                                <div className="frm_row search justify-content-start">
                                    <select className="form-select" {...register('year')}>
                                        {yearList.map((year) => (
                                            <option key={year} value={year}>{year}</option>
                                        ))}
                                    </select>
                                    <select className="form-select" {...register('month')}>
                                        {monthList.map((month) => (
                                            <option key={month} value={month}>{month}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="frm_row search justify-content-start">
                                <label htmlFor="" className="form-label frm_label">
                                    품목명
                                </label>
                                <input className="form-control" {...register('itemName')} />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="frm_row search justify-content-between">
                                <div className="d-flex">
                                    <div className="frm_row search justify-content-start">
                                        <label htmlFor="" className="form-label frm_label">
                                            규격
                                        </label>
                                        <input className="form-control" {...register('partNo')} />
                                    </div>
                                </div>
                                <button className="btn btn-info btn_search" onClick={handleSubmit(onSubmit)}>
                                    <img
                                        src={
                                            process.env.PUBLIC_URL +
                                            "/assets/images/icon_search.png"
                                        }
                                        alt=""
                                    />
                                    조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table_top">
                    <h6 className="table_stats">품목 제품 상세보기
                        (<span>{postCustomerAccountReadPtaTotalList?.result?.totalCount}건</span>)</h6>
                </div>
                <div className="table_scroll">
                    <table className="table table-bordered my_table table_modal m-0">
                        <thead>
                            <tr>
                                <th style={{ width: "4.53%" }}>No</th>
                                <th style={{ width: "14.56%" }}>기준</th>
                                <th style={{ width: "12.94%" }}>ERP거래처명</th>
                                <th style={{ width: "8.09%" }}>Pricing Group</th>
                                <th style={{ width: "8.09%" }}>Price Tier</th>
                                <th style={{ width: "8.09%" }}>ERP코드</th>
                                <th style={{ width: "12.94%" }}>Item Name</th>
                                <th style={{ width: "12.94%" }}>End Item Part No.</th>
                                <th>a</th>
                                <th>b</th>
                                <th>c</th>
                                <th>d</th>
                                <th>e</th>
                            </tr>
                        </thead>
                        <tbody>
                            {postCustomerAccountReadPtaTotalList?.result?.totalCount > 0 ? postCustomerAccountReadPtaTotalList?.result?.list?.map((item: any, index: number) => (
                                <tr>
                                    <td className="text-center">{index + 1 + ((pageNo - 1) * 10)}</td>
                                    <td>{item.standard}</td>
                                    <td>{item.erpAccountName}</td>
                                    <td>{item.pricingGroup}</td>
                                    <td>{item.priceTier}</td>
                                    <td>{item.erpCode}</td>
                                    <td>{item.itemName}</td>
                                    <td>{item.endItemPartNo}</td>
                                    <td>{item.levelA}</td>
                                    <td>{item.levelB}</td>
                                    <td>{item.levelC}</td>
                                    <td>{item.levelD}</td>
                                    <td>{item.levelE}</td>
                                </tr>
                            )) : <EmptyTableRow />}
                        </tbody>
                    </table>
                </div>
                <PaginationSub totalCount={postCustomerAccountReadPtaTotalList?.result?.totalCount} currentPage={pageNo}
                    onChangeCallback={setPageNo} />
            </form>
        </Modal.Body>
    </>
};


export default PTASearch;
